

/**
 * Bridge failure tag for an inserted eGK whose inSuite read returned no patient data.
 *
 * @since 1.1.7
 * @example
 * ```ts
 * const unreadable = cardReadFailureTag(error) === CARD_DATA_UNAVAILABLE_TAG
 * ```
 */
export const CARD_DATA_UNAVAILABLE_TAG = "CardDataUnavailableError";

/**
 * Extracts the bridge failure tag from a rejected card-reader RPC call.
 *
 * The kiosk RPC client rejects with a fiber failure wrapping the typed bridge error; a plain
 * tagged object is accepted as well so callers can classify failures without the runtime wrapper.
 * Returns `undefined` for untagged failures such as transport errors.
 *
 * @since 1.1.7
 * @example
 * ```ts
 * if (cardReadFailureTag(error) === CARD_DATA_UNAVAILABLE_TAG) {
 *   // show the unreadable-card state
 * }
 * ```
 */
export function cardReadFailureTag(error: unknown): string | undefined {
  const failure = error;
  return typeof failure === "object" &&
    failure !== null &&
    "_tag" in failure &&
    typeof failure._tag === "string"
    ? failure._tag
    : undefined;
}
